import { useEffect, useState } from "react";
import { KeyRound, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

const STORAGE_KEY = "kf-admin-pin";

export function useAdminPin() {
  const [pin, setPin] = useState(() => sessionStorage.getItem(STORAGE_KEY) || "");
  const clear = () => { sessionStorage.removeItem(STORAGE_KEY); setPin(""); };
  const save = (p) => { sessionStorage.setItem(STORAGE_KEY, p); setPin(p); };
  return { pin, save, clear };
}

export default function AdminPinGate({ children }) {
  const { pin, save, clear } = useAdminPin();
  const [input, setInput] = useState("");
  const [checking, setChecking] = useState(!!pin);
  const [authed, setAuthed] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!pin) { setChecking(false); return; }
    api.post("/admin/verify-pin", null, { headers: { "x-admin-pin": pin } })
      .then(() => setAuthed(true))
      .catch(() => { clear(); toast.error("Sesión de admin caducada"); })
      .finally(() => setChecking(false));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/admin/verify-pin", null, { headers: { "x-admin-pin": input } });
      save(input); setAuthed(true); toast.success("Acceso concedido");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally { setLoading(false); }
  };

  if (checking) return <div className="p-10 text-sm">Verificando…</div>;
  if (authed) return children;

  return (
    <div data-surface="audit" className="min-h-screen bg-[hsl(var(--audit-bg))] px-6 py-12">
      <div className="mx-auto max-w-md">
        <Link to="/" className="inline-flex items-center gap-1 text-sm text-[hsl(var(--audit-muted))]"><ArrowLeft size={14} /> Web pública</Link>
        <div className="mt-6 rounded-md border border-[hsl(var(--audit-border))] bg-white p-8">
          <div className="text-xs font-mono uppercase tracking-[0.25em] text-[hsl(var(--audit-muted))]">Restringido</div>
          <h1 className="mt-1 text-2xl font-bold">Panel interno</h1>
          <p className="mt-2 text-sm text-[hsl(var(--audit-muted))]">Introduce el PIN de administrador para continuar.</p>
          <form onSubmit={submit} data-testid="admin-pin-form" className="mt-6">
            <input
              autoFocus type="password" inputMode="numeric" required
              data-testid="admin-pin-input"
              value={input} onChange={(e) => setInput(e.target.value)}
              placeholder="PIN"
              className="w-full rounded-md border border-[hsl(var(--audit-border))] px-3 py-3 text-center text-lg tracking-[0.5em]"
            />
            <button type="submit" disabled={loading} data-testid="admin-pin-submit" className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-md bg-[hsl(var(--audit-text))] px-4 py-2 text-sm font-semibold text-white disabled:opacity-50">
              <KeyRound size={14} /> {loading ? "Verificando…" : "Entrar"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
